import gql from 'graphql-tag';
import { shipmentListFragment } from '../../../../../../graphql/query/shipmentList';

export default gql`
  query search($_id: ID) {
    shipmentList(_id: $_id, shipment_prefix: "GJD", see_detail: true) {
      shipment {
        ...shipmentFields
      }

      total_page
    }
  }

  ${shipmentListFragment}
`;
